<template>
  <div
    class="ds-myschedule-capsule ds-multi-ellipsis-1"
    :style="scheduleStyle(schedule)"
    :title="getScheduleTitle(schedule)"
    @click="goDetails(schedule)"
  >
    <span :style="scheduleAbbreStyle(schedule)">{{
      schedule.agendaTypeVo.abbre
    }}</span>
    <span>{{ schedule.theme }}</span>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMyScheduleCapsule",
  mixins: [$mixins.control],
  ctrlCaption: "个人日程-胶囊",
  design: {
    isMask: false,
  },
  props: {
    schedule: {
      type: Object,
      default: () => {
        return {
          agendaTypeVo: {},
        };
      },
    },
    // 跳转-新增、查看
    editPath: {
      type: String,
      default: "",
    },
  },

  data() {
    return {};
  },
  computed: {},
  created() {},

  methods: {
    // 计算样式
    scheduleStyle(schedule) {
      return (
        schedule && {
          backgroundColor: schedule.agendaTypeVo.colorValue + "10",
        }
      );
    },
    scheduleAbbreStyle(schedule) {
      return (
        schedule && {
          backgroundColor: schedule.agendaTypeVo.colorValue,
        }
      );
    },

    // 日程提示信息
    getScheduleTitle(schedule) {
      if (!schedule) return "";
      let { endTime, startTime, theme } = schedule;
      let res = [theme, startTime + " - " + endTime];
      return res.join("\n");
    },
    // 查看详情
    goDetails(e) {
      let isview = e.isOwn == "1" ? "0" : "1";
      this.$openDialog({
        title: "查看日程",
        width: "80%",
        height: "70vh",
        params: {
          path:
            this.$replace(this.editPath) + "&isview=" + isview + "&id=" + e.id,
        },
      });
    },
  },
});
</script>
